(() => {
  // Routines page: finder chips (scroll + highlight) and a sticky offer bar.
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFinder(scope) {
    scope.querySelectorAll('[data-drf-rt-target]').forEach((chip) => {
      if (chip.dataset.drfBound) return;
      chip.dataset.drfBound = '1';
      chip.addEventListener('click', () => {
        const card = document.getElementById(chip.dataset.drfRtTarget);
        if (!card) return;
        scope.querySelectorAll('[data-drf-rt-target]').forEach((c) => c.classList.toggle('is-active', c === chip));
        document.querySelectorAll('.drf-rt-card.is-picked').forEach((c) => c.classList.remove('is-picked'));
        card.classList.add('is-picked', 'is-in');
        card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center', inline: 'center' });
      });
    });
  }

  function initSticky() {
    const bar = document.querySelector('[data-drf-rt-sticky]');
    const hero = document.querySelector('[data-drf-rt-hero]');
    const grid = document.getElementById('drf-routinen');
    const close = document.querySelector('[data-drf-rt-close]');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    const state = { hero: true, grid: false, close: false };
    const update = () => bar.classList.toggle('is-visible', !state.hero && !state.grid && !state.close);
    const watch = (el, key) => {
      if (!el) return;
      new IntersectionObserver((entries) => {
        entries.forEach((e) => { state[key] = e.isIntersecting; });
        update();
      }, { threshold: 0 }).observe(el);
    };
    watch(hero, 'hero');
    watch(grid, 'grid');
    watch(close, 'close');
  }

  function init() { initFinder(document); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', (e) => initFinder(e.target));
})();
